// router/index.js (只修改路由守卫部分)
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'; // 引入 store
import { Notification } from 'element-ui'; // 引入 Notification

import Login from '@/views/auth/Login.vue';
import Register from '@/views/auth/Register.vue'; // 修正了这里的命名
import ForgotPassword from '@/views/auth/ForgotPassword.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import SetPassword from '@/views/auth/SetPassword.vue';

import UserData from '@/views/admin/user/index.vue';
import EditData from '@/views/admin/user/edit.vue';

import Subscription from '@/views/admin/subscription/index.vue';
import Curriculum from '@/views/admin/curriculum/index.vue';
import CurriculumList from '@/views/admin/curriculum/index.vue';
import CourseDetail from '@/views/admin/curriculum/CourseDetail.vue';

import Indent from '@/views/admin/indent/index.vue';
import Download from '@/views/admin/download/index.vue';
import Address from '@/views/admin/location/index.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/user' }, // 默认跳转到用户页面
  {
    path: '/sign_in',
    component: Login,
    meta: {
      public: true // 公开页面，不需要登录
    }
  },
  {
    path: '/sign_up',
    component: Register,
    meta: {
      public: true, // 公开页面，不需要登录
      requiresRegistrationEnabled: true // 需要检查注册是否启用
    }
  },
  {
    path: '/forgot_password',
    component: ForgotPassword,
    meta: {
      public: true // 公开页面，不需要登录
    }
  },
  {
    path: '/reset_password',
    component: ResetPassword,
    meta: {
      public: true // 公开页面，不需要登录
    }
  },
  {
    path: '/user/edit',
    component: EditData,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: SetPassword,
    meta: {
      public: true // 公开页面，不需要登录
    }
  },
  {
    path: '/user',
    component: UserData,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/subscription',
    component: Subscription,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/indent',
    component: Indent,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/download',
    component: Download,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/address',
    component: Address,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/curriculum/detail',
    component: CourseDetail,
    meta: {
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/curriculum',
    component: Curriculum,
    meta: {
      requiresAuth: true // 需要登录
    },
    children: [
      { path: '', redirect: 'list' },
      { path: 'list', component: CurriculumList },
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

// 路由守卫 - 检查登录状态和注册功能
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  // 1. 检查是否需要登录
  if (to.meta.requiresAuth && !token) {
    console.warn('未登录，重定向到登录页面');
    Notification({
      title: '警告',
      message: '未登录，请登录',
      type: 'warning'
    });
    next('/sign_in');
    return;
  }

  // 2. 检查注册功能是否启用（针对注册页面）
  if (to.meta.requiresRegistrationEnabled) {
    const isRegistrationEnabled = store.getters['portal/isRegistrationEnabled'];

    if (!isRegistrationEnabled) {
      console.warn('注册功能未启用，已重定向到登录页面');
      Notification({
        title: '警告',
        message: '注册功能未启用',
        type: 'warning'
      });
      next('/sign_in');
      return;
    }
  }

  // 3. 如果已登录用户访问登录页面，重定向到用户页面
  if (to.path === '/sign_in' && token) {
    next('/user');
    return;
  }

  next();
});

export default router;